import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import {
  Autocomplete,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TablePagination,
  TextField,
} from "@mui/material";
import { AddCircleOutline, MoreVert } from "@mui/icons-material";
import UserModal from "./modal/user";
import { listUsersNomalService } from "./service/userService";
import * as Api from "../../../api/src/index";
import { Role } from "../../../common/constant/constant";
import { AuthenService } from "../../../services/authenServices";
import moment from "moment";
interface HeadCell {
  disablePadding: boolean;
  id: string;
  label: string;
  numeric: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone number",
  },
  {
    id: "country",
    numeric: false,
    disablePadding: false,
    label: "Country",
  },
  {
    id: "address",
    numeric: false,
    disablePadding: false,
    label: "Address",
  },
  {
    id: "company",
    numeric: false,
    disablePadding: false,
    label: "Company",
  },
  {
    id: "loginTime",
    numeric: false,
    disablePadding: false,
    label: "Login Time",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
];

interface EnhancedTableProps {
  numSelected?: number;
  onRequestSort?: (event: React.MouseEvent<unknown>, property: string) => void;
  orderBy?: string;
  rowCount?: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort && onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell
          key={"action"}
          align={"center"}
          padding={"normal"}
          sortDirection={false}
        ></TableCell>
      </TableRow>
    </TableHead>
  );
}

export default function UserNomals() {
  const { GetRoles } = AuthenService();
  const {
    handleShowMenuClick,
    handleMenuClose,
    AddNew,
    EditObj,
    getUsers,
    listData,
    anchorEl,
    query,
    userModalProp,
    onPageChange,
    onRowsPerPageChange,
    onKeyWordBlur,
    openMenu,
    closeModal,
    updateStatus,
    onChangeComapny,
    listCompanyData,
    SetRole,
    removeRole,
    rowSelected,
    CompanySelected,
  } = listUsersNomalService();
  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <Box
          display="grid"
          gap={2}
          style={{ padding: "10px 10px", display: "flex" }}
        >
          {GetRoles().includes(Role.sysadmin) && (
            <Box>
              <Autocomplete
                options={listCompanyData}
                getOptionLabel={(option) => option.name || ""}
                value={CompanySelected}
                size="small"
                sx={{ width: 300 }}
                onChange={(o, val) => {
                  onChangeComapny(val?.id || 0);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="companyId"
                    label="Company"
                    onChange={(val) => {
                      if (val.target.value === "") {
                        onChangeComapny(0);
                      }
                    }}
                  />
                )}
              />
            </Box>
          )}

          <Box>
            <TextField
              size="small"
              onBlur={(e) => {
                onKeyWordBlur(e.target.value);
              }}
              label="Key word"
            />
          </Box>
          <Box flex={1} textAlign="right">
            <Button
              variant="outlined"
              onClick={() => {
                AddNew();
              }}
              startIcon={<AddCircleOutline />}
            >
              Add
            </Button>
          </Box>
        </Box>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={"small"}
          >
            <EnhancedTableHead />
            <TableBody>
              {listData?.result?.items?.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.id}
                    sx={{ cursor: "pointer" }}
                  >
                    <TableCell component="th" id={labelId} scope="row">
                      {`${row.firstName} ${row.lastName}`}
                    </TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.phoneNumber}</TableCell>
                    <TableCell align="left">{row.country?.niceName}</TableCell>
                    <TableCell align="left">{row.address}</TableCell>
                    <TableCell align="left">{row.company?.name}</TableCell>
                    <TableCell align="left">
                      {row.loginTime
                        ? moment(row.loginTime).format("DD/MM/YYYY HH:mm:ss")
                        : ""}
                    </TableCell>
                    <TableCell align="left">
                      {row.userRoles
                        ?.map((o) => o.role?.displayName)
                        .join(", ")}
                    </TableCell>
                    <TableCell align="left">
                      {row.status === Api.RowStatus.Active
                        ? "Active"
                        : "InActive"}
                    </TableCell>
                    <TableCell align="center" width={30}>
                      <IconButton
                        id="basic-button"
                        aria-controls={openMenu ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? "true" : undefined}
                        onClick={(e) => {
                          handleShowMenuClick(e, row);
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                EditObj();
              }}
            >
              Edit
            </MenuItem>
            { }
            <MenuItem
              onClick={() => {
                updateStatus(Api.RowStatus.Delete);
              }}
            >
              Delete
            </MenuItem>
            {!rowSelected?.userRoles?.some((o) => o.role?.name === Role.comadmin) && (
              <MenuItem
                onClick={() => {
                  SetRole();
                }}
              >
                Set role company admin
              </MenuItem>)}
            {rowSelected?.userRoles?.some((o) => o.role?.name === Role.comadmin) && (
              <MenuItem
                onClick={() => {
                  removeRole();
                }}
              >
                Remove role company admin
              </MenuItem>
            )}
          </Menu>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={listData?.result?.total || 0}
          rowsPerPage={query?.limit || 0}
          page={query?.page || 0}
          onPageChange={onPageChange}
          onRowsPerPageChange={(e) => {
            onRowsPerPageChange(e);
          }}
        />
      </Paper>
      {userModalProp.formStatus && (
        <UserModal
          companys={listCompanyData}
          userItem={userModalProp.userItem}
          formStatus={userModalProp.formStatus}
          onClose={(action) => {
            if (action === "Save" && query) getUsers(query);
            closeModal();
          }}
        ></UserModal>
      )}
    </Box>
  );
}
